// extracted by mini-css-extract-plugin
module.exports = {"base":"_7a3fb80146--base--_8_8v","triangle":"_7a3fb80146--triangle--UDnIt","content":"_7a3fb80146--content--NW2AD","close":"_7a3fb80146--close--_rLgP"};